<template>
  <div>
    <div class="pc">
      <slot name="pc"></slot>
    </div>
    <div class="mobile">
      <slot name="mobile"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'wrapper',
  data() {
    return {

    };
  }
};
</script>
<style scoped>
  @media screen and (max-width: 992px) {
    .pc {
      display: none;
    }
  }

  @media screen and (min-width: 993px) {
    .mobile {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/wrapper.vue